export default __webpack_public_path__ + "static/spotifybrowser-3d6105c999595c51aad755bb4511ce95.png";